"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fillScreen(graphElements, graphElement) {
    // setTimeout puts the code at the end of the rendering queue, as the rendering of the
    // fill-screen class has not been processed yet.
    setTimeout(function () {
        graphElements.forEach(function (dataGraphComp) {
            dataGraphComp.nativeElement.style.display = 'none';
        });
        graphElement.nativeElement.style.display = null;
        graphElement.drawGraph();
    }, 0);
}
exports.fillScreen = fillScreen;
function shrinkGraph(graphElements) {
    graphElements.forEach(function (dataGraphComp) {
        dataGraphComp.nativeElement.style.display = null;
        setTimeout(function () {
            dataGraphComp.drawGraph();
        }, 0);
    });
}
exports.shrinkGraph = shrinkGraph;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JhcGgtdXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImdyYXBoLXV0aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQSxvQkFBMkIsYUFBMkIsRUFBRSxZQUFvQjtJQUN4RSxzRkFBc0Y7SUFDdEYsZ0RBQWdEO0lBQ2hELFVBQVUsQ0FBQztRQUNQLGFBQWEsQ0FBQyxPQUFPLENBQUMsVUFBQyxhQUFhO1lBQ2hDLGFBQWEsQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUM7UUFDdkQsQ0FBQyxDQUFDLENBQUM7UUFDSCxZQUFZLENBQUMsYUFBYSxDQUFDLEtBQUssQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO1FBQ2hELFlBQVksQ0FBQyxTQUFTLEVBQUUsQ0FBQztJQUM3QixDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUM7QUFDVixDQUFDO0FBVkQsZ0NBVUM7QUFFRCxxQkFBNEIsYUFBdUI7SUFDL0MsYUFBYSxDQUFDLE9BQU8sQ0FBQyxVQUFDLGFBQWE7UUFDaEMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsT0FBTyxHQUFHLElBQUksQ0FBQztRQUNqRCxVQUFVLENBQUM7WUFDUCxhQUFhLENBQUMsU0FBUyxFQUFFLENBQUM7UUFDOUIsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO0lBQ1YsQ0FBQyxDQUFDLENBQUM7QUFDUCxDQUFDO0FBUEQsa0NBT0MifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/data/common/graph-util.ts
// module id = 271
// module chunks = 0